// eslint-disable-next-line import/prefer-default-export
export const APPLICANT_ES = {
  // common
  Cancel: 'Cancelar',
  Accept: 'Aceptar',
  ImSure: 'Estoy seguro',
  Send: 'Enviar',
  Applicant: 'Candidato',
  AddedBy1: 'Agragdo por',
  AddedBy2: 'el: ',
  Of: 'de ',

  // menuPop
  GeneralMenu: 'General',
  CommentsMenu: 'Comentarios',
  ScoresMenu: 'Calificaciones',
  TransferMenu: 'Transferir',
  InterviewMenu: 'Entrevista',
  ActivityMenu: 'Actividad',
  BackgroundMenu: 'Antecedente',
  testingMenu: 'Prueba',

  // Sub menu pop
  SubMenuHistory: 'Historial',
  SubMenuApplications: 'Postulaciones',

  // Table
  Vacancy: 'Vacante',
  Application: 'Postulación',
  Status: 'Estatus',
  Prom: 'Calif.',
  noName: 'No se recupero el nombre',

  // pdfViewer
  InvalidFile: 'El archivo es inválido o está dañado',
  NoFile: 'No hay archivo pero puedes subir un nuevo CV',
  ServerError: 'El servidor no responde',
  ApiError: 'Error en el servidor API',
  NoFileFound: 'No se encontró ningún archivo',
  GeneralError: 'Error, algo salió mal.',
  LoadingPDF: 'Cargando PDF',
  FailureMessage: 'Ya hemos intentado convertir el CV pero no lo logramos',
  uploadFile: 'Arrastra tus archivos acá para subirlos',
  onlyPDF: 'Solo archivos PDF',
  FailureMessageFromBase: 'No pudimos convertir el archivo, por favor inténtalo desde la vacante.',
  WaitMessage: 'Espera, estamos convirtiendo el archivo. No te vayas.',
  tooltipDownload: 'Descargar',
  // Tabs
  FreeCv: 'CV LIBRE',
  Testing: 'PRUEBA',
  CvWithBiases: 'CV CON SESGOS',
  CvWithoutBiases: 'CV SIN SESGOS',
  // testing
  PercentageCorrect: 'correctas',
  Competence: 'Competencia',
  ApplicantsAnswer: 'Respuesta del postulante',
  AvailableOptions: 'Opciones disponibles: ',
  Correct: 'Correcta',
  Incorrect: 'Incorrecta',
  DidNotAnwer: 'No respondió',
  PersonalQuestionnaire: 'Cuestionario Personal',
  ResultQuestions: 'Resultado',

  // gmailIntegration
  EmailHeader: 'Personalizar correo',
  EmailMessage: 'Enviaremos el correo por Gmail',
  Subject: 'Asunto:',
  Emails: 'Correos',
  placeholderTextArea: 'Redacte su mensaje',

  // unlinked gmail
  UnlinkedHeader: 'No has vinculado tu cuenta de Gmail',
  UnlinkedMessage1: 'Ahora puedes vincular tu cuenta de Gmail desde aquí',
  UnlinkedMessage2: '¿Por qué no lo intentas?',
  LinkAccount: 'Vincular cuenta',
  NotNow: 'Ahora no',

  // deleteCandidate
  DeleteHeader: 'Eliminar candidato',
  DeleteMessage1: '¿Está seguro que quiere eliminar a este candidato?',
  DeleteMessage2: 'Cuidado, esta acción no se puede revertir',

  // liteView
  LiteHeader: 'Compartir candidato (Lite View)',
  LiteMessage: 'Comparte un candidato con personas de tu empresa o externas para que puedan ver el perfil',
  Setup: 'Configuración',
  ExpirationDate: 'Fecha de expiración',
  Never: 'Nunca',
  AnyoneCanSee: '¿Cualquier persona puede acceder?',
  Yes: 'Sí',
  No: 'No',
  SelectUsers: 'Seleccione usuarios',
  Link: 'Liga para compartir',
  CopyLink: 'Copiar liga',
  CopiedLink: 'Liga copiada',
  Saved: 'Guardado',

  // scheduleEvent
  AddEvent: 'Nuevo evento',
  placeholderTitle: 'Título',
  DateAssignment: 'Asignación de fecha',
  placeholderDescription: 'Descripción del evento',
  InitialDate: 'Inicio',
  FinalDate: 'Final',
  AskMeet: 'Solicitar Meet',
  NotifyGuests: 'Notificar invitados',
  placeholderEmail: 'Correo invitado',
  EventTitle: 'Título del evento',
  EventDate: 'Fecha del evento',
  Time: 'Tiempo',
  TextTime: 'Todo el día',
  InviteMembers: 'Miembros invitados',
  SaveEvent: 'Guardar',
  MessageInputsEmpty: 'Por favor no deje vacio los campos marcados con *',
  AddDescription: 'Agregar descripción',

  // generalStep
  AppliedOn: 'Solicitó el:',
  AppliedFrom: 'Solicitó desde:',
  Email: 'Correo:',
  Description: 'Descripción:',
  ApplicantDidNotComment: 'El postulante no dejó comentario',
  SingleActions: 'Acciones individuales',
  ExtraFiles: 'Archivos extra',
  AppliccantHistory: 'Historial',
  ToggleUpHistory: 'Mostrar historial',
  ToggleDownHistory: 'Ocultar historial',
  moveOtherColumn: 'Mover a otra columna',
  select: 'Seleccionar',
  move: 'Mover',
  PhoneSecondary: 'Teléfono secundario',
  EmailSecondary: 'Correo secundario',
  // commentsStep
  Question: '¿Qué opinas?',
  TypeHere: 'Escribe aquí tu comentario',
  Post: 'Publicar',
  Edit: 'Editar',
  EditComment: 'Editar comentario',
  NoComments: 'Aún no hay comentarios, sé el primero',
  // scoresStep
  Scores: 'Calificaciones',
  Score: 'Calificar',
  AverageScore: 'Promedio',
  OtherScores: 'Otras calificaciones',
  NoScores: 'Aún no hay calificaciones, sé el primero.',
  CannotScore: 'Este candidato no se puede calificar desde base de candidatos.',
  AlreadyScored: 'Ya has calificado a este postulante',
  UpdateScore: 'Actualizar calificación',
  tooltipAddCriterion: 'Agregar criterio de calificación',
  placeholderNameCriterion: 'Nombre del criterio',
  CriteriaMessage1: 'Agregar criterios a evaluar',
  CriteriaMessage2: 'Serán visibles en toda la vacante',
  AddCriteriaConfirmation: 'Este criterio no podrá ser modificado, ¿quiere continuar?',
  // transferStep
  Transfer: 'Transferir',
  Invite: 'Invitar',
  placeholderSearch: 'Buscar vacante',
  Vacancies: 'Vacantes',
  PostDate: 'Fecha de publicación',
  Actions: 'Acciones',
  tooltipTransfer1: 'Se transferirá al candidato y solo se le notificará.',
  tooltipInvite1: 'Se le enviará un correo con la liga de su vacante.',
  tooltipTransfer2: 'Transferir candidato',
  tooltipInvite2: 'Invitar candidato',
  // activityStep
  ScoreRegistered: 'Registró calificación',
  ScoreUpdated: 'Actualizó calificación',
  CommentRegistered: 'Registró comentario',
  CommentUpdated: 'Actualizó comentario',
  copyEmail: 'Email Copiado',
  deleteSave: 'Eliminado de guardados',
  addSaved: 'Guardado',
  addFiled: 'Archivo guardado',
  sendOutlook: 'Correo enviado por Outlook',
  sendGmail: 'Correo enviado por Gmail',
  transferred: 'Candidato transferido a otra vacante',
  invited: 'Candidato Invitado a otra vacante',
  sendTest: 'Prueba enviada',
  updateTest: 'Prueba actualizada',
  sendInvitation: 'Invitación de Meet enviada',
  NoRegisters: 'Aún no hay registros',
  // background
  Text1: '¿Necesitas saber los antecedentes del postulante?',
  Text2: 'Para este proceso, requerimos de la CURP del postulante',
  Text3: 'A este postulante no se le ha realizado una investigación previa',
  Text4: '*Solo disponible en México.*',
  CurpCandidate: 'CURP del postulante',
  CandidateAgrees: 'El postulante aceptó investigar sus antecedentes',
  AllFields: 'Rellene todos los campos',
  CheckForFree: 'Revisar antecedentes gratis',
  Consulting: 'Consultando, espere por favor...',

  tooltipSchedule: 'Agendar evento',
  tooltipSave: 'Guardar en Base como destacado',
  tooltipDontSave: 'Dejar de guardar candidato',
  tooltipSendEmail: 'Enviar correo',
  tooltipCopyEmail: 'Copiar correo',
  tooltipSendWhats: 'Enviar WathsApp',
  tooltipShare: 'Compartir candidato',
  tooltipReject: 'Rechazar candidato',
  tooltipMove: 'Mover candidato',
  tooltipAddFile: 'Agregar documento',

  // Notifications
  MissingApproval: 'Falta aprobación del postulante',
  CurpInvalid: 'CURP inválida',
  CriterionAlreadyAdded: 'Criterio ya agregado',
  CheckAllData: 'Verifique los datos necesarios',
  FillAllFields: 'Por favor rellene todos los campos',
  MessageSent: 'Mensaje enviado',
  MessageSent2: 'Su mensaje ha sido enviado',
  MessageFailed: 'Mensaje fallido',
  MessageNotSent: 'Mensaje no enviado',
  EmailCopied: 'Correo copiado',
  ChangeMade: 'Cambio realizado',
  SimpleServerError: 'Error en el servidor',
  booleanQuestion: 'Pregunta cerrada',
  multipleOptions: 'Opción múltiple',
  rangesQuestion: 'Pregunta por rangos',
  missingType: 'Falta tipo de pregunta',
  automaticQuestion: 'Pregunta automática',
  average: 'Promedio',
  free: 'Respuesta libre',

  // Move columns
  NewName: 'Nuevo nombre',
  Unnamed: 'Sin nombre',
  PersonalFilter1: 'Filtro personal 1',
  PersonalFilter2: 'Filtro personal 2',
  RejectedWillBeNotified: 'Se enviará un correo mencionando su rechazo',
  NewCandidates: 'Nuevos candidatos',
  Accepted: 'Aceptados',
  Rejected: 'Rechazados',
  npsName: 'NPS name',
  npsDate: 'Fecha de envío',
  npsIgnored: 'Ignorado',
  npsRead: 'Leido',
  npsAnswered: 'Respondido',
  npsPending: 'Pendiente',

  // categories
  Administration: 'Administración',
  Banking: 'Banca',
  Law: 'Derecho',
  Development: 'Desarrollo web / TI',
  Design: 'Diseño',
  Edtech: 'Edtech',
  Finances: 'Finanzas',
  Fintech: 'Fintech',
  Healathtech: 'Healthtech',
  Humanities: 'Humanidades',
  CreativeIndustries: 'Insustrias creativas',
  Engineering: 'Ingenierías',
  Insurtech: 'Insurtech',
  Legal: 'Legal',
  Logistics: 'Logística',
  Management: 'Management',
  DigitalMarketing: 'Marketing digital',
  Fashion: 'Moda',
  OngSocial: 'ONGs/ Social, Operaciones',
  Psychology: 'Psicología',
  Proptech: 'Proptech',
  HumanResources: 'Recursos Humanos',
  Health: 'Salud',
  Insurances: 'Seguros',
  Sells: 'Ventas',
  Other: 'Otros',
  extension: 'Extensión',

  // InterView
  wishes: 'Deseos',
  interests: 'Intereses',
  opportunity: 'Área de interés',
  selected: 'Seleccione área',
  search: '¿Qué posiciones buscas?',
  IndustriesInterest: 'Industrias de interés',
  idiomas: 'Idiomas',
  selectLanguages: 'Seleccione idiomas',
  minimumSalary: 'Sueldo mínimo',
  DesiredLocation: 'Ubicación deseada',
  availability: 'Disponibilidad para trabajo remoto',
  relocationAvailability: 'Disponibilidad de reubicación',
  languageLevel: 'Nivel de idiomas',
  interesesProfesionales: 'Intereses profesionales',
  whatWishes: '¿Cuáles son los deseos del candidato?',
  notes: 'Notes',
  save: 'Guardar',
  motherTongue: 'Lengua Materna',
  beginner: 'Nivel iniciación',
  middle: 'Nivel intermedio',
};
